import Vue from 'vue';
import Vuex from 'vuex';
import env from './modules/env';
import user from './modules/user';
import aiGame from './modules/aiGame';
import tsumeGame from './modules/tsumeGame';
import verification from './modules/verification';
import course from './modules/course';
import aiCourse from './modules/aiCourse';
import maintenance from './modules/maintenance';
import teacherManagement from './modules/teacherManagement';
import multimediaClassroom from './modules/multimediaClassroom';
import ladder from './modules/ladder';
import popup from './modules/popup';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    env,
    user,
    aiGame,
    tsumeGame,
    verification,
    course,
    aiCourse,
    maintenance,
    teacherManagement,
    multimediaClassroom,
    ladder,
    popup,
  },
});
